import React from 'react'
import { InfoIcon } from 'lucide-react';
import moment from 'moment';
import { useContext, useState } from 'react';
import { Context } from 'Context/Context';
import { useNavigate } from 'react-router-dom';


function LegalDateCaseInfo({
    detail,
    userInfo,
  onAttorney = false

}) {
    const [showAiInfo, setShowAiInfo] = useState(false);
    const navigate = useNavigate();

  return (
     <div className={onAttorney ? 'lg:text-base text-xs h-[24px] items-center relative  w-full flex  flex-row lg:items-start ': 'w-full lg:text-base items-center mb-1 font-normal lg:font-bold lg:justify-left text-xs flex lg:flex-col flex-row'}>
          <div className={ onAttorney ? "":"lg:mb-1 lg:w-full w-[150px] font-medium"}>Deadline to file  lawsuit:&nbsp;</div>
          <div className={ onAttorney ? " flex items-center justify-center"  : " lg:mb-2 flex lg:items-left lg:w-full items-center" }
            onMouseEnter={() => setShowAiInfo(true)}
              onMouseLeave={() => setShowAiInfo(false)}
          >
            
            {userInfo?.isActiveSubscription ?
            (detail?.aiDate ?  moment(detail?.aiDate).format("MMMM DD, YYYY") : 'N/A' ): 
             <span className='flex text-sm'
            
              onClick={() => navigate("/attorney/subscription")}
             ><span className='blur-sm'>11/22/32 </span></span> }
             <InfoIcon
            
             className='w-[15px] ml-2'/>
             {showAiInfo &&
             <div className='absolute bg-white w-[280px] text-gray-600 p-2 z-10 right-0 top-0 left-0 rounded border top-12  border-gray-200 shadow-md text-xs'>
              This is an AI generated estimate of the deadline to file a lawsuit.
              {userInfo?.isActiveSubscription ? '' :<span className='text-xs text-gray-500'> (Subscription required to see the actual date)</span>}
             </div>
             }
             </div>
       
        </div>
  )
}

export default LegalDateCaseInfo
